import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import ShowcaseLanding from "./components/ShowcaseLanding";
import SimpleTest from "./components/SimpleTest";
import BlogPage from "./components/BlogPage";
import BlogArticle from "./components/BlogArticle";
import AdminPanel from "./components/AdminPanel";
import ContactPage from "./components/ContactPage";
import FormationPage from "./components/FormationPage";
import PrivacyPage from "./components/PrivacyPage";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Home = () => {
  const helloWorldApi = async () => {
    try {
      const response = await axios.get(`${API}/`);
      console.log(response.data.message);
    } catch (e) {
      console.error(e, `errored out requesting / api`);
    }
  };

  useEffect(() => {
    helloWorldApi();
  }, []);

  return <ShowcaseLanding />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogArticle />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/contatti" element={<ContactPage />} />
          <Route path="/formazione" element={<FormationPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;